<template>
  <el-form-item
    :label="name"
    :prop="code"
    :rules="rules"
  >
    <el-select
      v-model="val"
      :disabled="disabled"
      placeholder=" -- 请选择 -- "
      :clearable="true"
      @change="change"
    >
      <el-option
        v-for="item in options"
        :key="item[keyField]"
        :label="item[valueField]"
        :value="item[keyField]"
      />
    </el-select>
  </el-form-item>
</template>

<script>
import { verify } from '@/utils/ik/verify/verify.js'

export default {
  name: 'IkFormSelect',
  model: {
    // 属性
    prop: 'value',
    // 事件
    event: 'change'
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: String,
      default: ''
    },
    keyField: {
      type: String,
      default: 'key'
    },
    valueField: {
      type: String,
      default: 'value'
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tips: {
      type: String,
      default: ''
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      val: '',
      errorSign: false,
      message: ''
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  watch: {
    value: {
      handler(value) {
        if (["", null, undefined].some(v => value === v)) {
          this.val = this.defaultValue
        } else {
          this.val = value
        }
        this.change(this.val)
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 字段变更
     * @param value
     */
    change(value) {
      // 取值验证
      this.message = verify(value, this.rules)
      this.errorSign = this.message !== null
      // 空值验证
      if (this.getRequire && this.isNull()) {
        this.errorSign = true
        this.message = "必填项，不可为空"
      }
      // v-model实现触发方法
      this.$emit('change', value)
    },
    isNull() {
      return this.val === '' || this.val === null || this.val === undefined
    },
    reset() {
      this.value = this.defaultValue
    },
    clean() {
      this.value = ''
    }
  }
}
</script>

<!--<style scoped>-->
<!--::v-deep.require > .el-input > .el-input__inner {-->
<!--  border: red 1px solid;-->
<!--}-->
<!--</style>-->
<style lang="scss" scoped>
//.el-form-item {
//  margin-bottom: 12px;
//  width: 100%;
//}
//.el-select {
//  width: 100%;
//}
//.ik-select{
//  ::v-deep.el-form-item__label {
//    // width: 210px!important;
//    width: 180px;
//    overflow: hidden;
//    text-overflow: ellipsis;
//    white-space: nowrap;
//  }
//  ::v-deep.el-form-item__content {
//    width: calc(100% - 180px);
//    overflow: hidden;
//    text-overflow: ellipsis;
//    white-space: nowrap;
//  }
//}
//.item{width:calc(100% - 30px)}
</style>
